<template>
  <div>
    <sidebar-release
      :items="releases"
      :loader="loader"
      :toggleSidebarReleases="visibleSideBarReleases"
      @closeSidebarReleases="closeSidebarReleases"
    />
    <base-nav
      container-classes="container-fluid prl-30"
      class="navbar-top navbar-expand"
      :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : ''"
      :itemsBread="itemsBread"
      :logo="
        require('rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility.png')
      "
      app="INTERNAL"
    >
      <ul class="navbar-nav align-items-center ml-md-auto"></ul>
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <!-- <base-dropdown
          class="nav-item notify"
          tag="li"
          title-classes="nav-link"
          title-tag="a"
          icon="flaticon-notification-bell-outline-interface-symbol"
          menu-classes="dropdown-menu-xl dropdown-menu-right p-0 overflow-hidden"
          :badge="notifications.length"
        >
          <template>
          
            <div class="header-notify">
              <div class="row">
                <div class="col-6">
                  <span class="text-info-notify">
                    <strong class="text-primary">{{
                      notifications.length
                    }}</strong>
                    new notifications.
                  </span>
                </div>
                <div class="col-6 text-right">
                  <span class="text-link">Mark all as read</span>
                </div>
              </div>
            </div>

            si no hay notificaciones mostrar esto
            <base-alert type="secondary" class="alert-box mx-3">
              <h4><strong>Waiting Notifications!</strong></h4>

              There are no notifications

              <img
                src="~rhomtrip_assets/src/img/character/notification.png"
                alt="Rhomtrip waiting"
                class="character"
              />
            </base-alert>

            <div class="list-group list-group-flush list-scroll">
              <basenotifications
                v-for="(item, index) in notifications"
                :key="index"
                :to="item.to"
                :type="item.type"
                :user="item.responsible"
                :title="item.title"
                :message="item.message"
                :datetime="item.timestamps"
                :read="item.viewed"
              ></basenotifications>
            </div>
          
            <router-link
              to="/notifications"
              class="
               button-bar
              "
              >View all</router-link
            >
          </template>
        </base-dropdown>
 -->
        <base-button
          type="outline-neutral"
          class="button-wn "
          @click="openSideBarReleases"
        >
          <i class="flaticon-history-1 "></i> What's new
          <span v-if="latestNewsAvailable" class="point-status danger"></span>
        </base-button>
        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        >
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <div class="media align-items-center">
              <span class="img-profile">
                <div
                  class="img-user-list"
                  v-bind:style="{
                    backgroundImage: profile.url_picture
                      ? `url('${profile.url_picture}')`
                      : `url('${imageProfile}')`
                  }"
                ></div>
              </span>
              <div class="media-body ml-1 d-none d-lg-block">
                <span class="link-drop capitalize"
                  >{{ profile.first_name }} {{ profile.last_name }}</span
                >
              </div>
            </div>
          </a>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
              <span class="capitalize no-desk"
                >{{ profile.first_name }} {{ profile.last_name }}</span
              >
            </div>
            <router-link to="/my-profile" class="dropdown-item">
              <i class="flaticon-profile"></i>
              <span>My profile</span>
            </router-link>

            <!-- <router-link to="/notifications" class="dropdown-item">
              <i
                class="flaticon-notification-bell-outline-interface-symbol"
              ></i>
              <span>Notifications</span>
            </router-link> -->
            <router-link to="/help" target="_blank" class="dropdown-item">
              <i class="flaticon-question"></i>
              <span>Help</span>
            </router-link>

            <span
              class="dropdown-item d-xl-none d-lg-none d-md-none d-sm-block d-block"
              @click="openSideBarReleases"
            >
              <i class="flaticon-history-1"></i>
              <span>What's new</span>
              <span v-if="latestNewsAvailable" class="point-status danger">
              </span>
            </span>

            <span class="dropdown-item" @click="about = true">
              <i class="flaticon-warning"></i>
              <span>About RhomTrip</span>
            </span>

            <div class="dropdown-divider"></div>
            <a href="javascript:;" @click="logout" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
        <li class="nav-item d-lg-none ml-3">
          <!-- Sidenav toggler -->
          <div
            class="sidenav-toggler"
            :class="{
              active: $sidebar.showSidebar,
              'sidenav-toggler-light': type === 'light'
            }"
            @click="toggleSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
      </ul>
    </base-nav>
    <modal :show.sync="about">
      <template slot="header">
        <h5 class="subtitle mb-3" id="modalAbout">About RhomTrip</h5>
      </template>
      <div class="col-12">
        <img
          src="~rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility.png"
          alt="RhomTrip"
          class="logo-min-about mt-4"
        />

        <div class="text-center">
          <p class="text-black mb-0">
            Version {{ systemInfo.release.version }}
          </p>
          <p class="upper font-weight-700">Enterprise Edition</p>
        </div>

        <div class="border-top pt-3 pb-0">
          <p class="text-center lh-140">
            The all-in-one tool, RhomTrip Mobility, is a cloud-based solution
            that caters to the needs of small and medium-sized suppliers, as
            well as a wide range of travel partners including Agents, Agencies,
            and suppliers.
          </p>
        </div>
      </div>

      <div class="row border-top pt-1 pb-1">
        <div class="row justify-content-center">
          <div
            class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
          >
            <a href="https://www.iata.org" target="_blank">
              <img
                class="img-fluid"
                src="~rhomtrip_assets/src/img/partnership/iata-rhomtrip.png"
                alt="iata-code"
            /></a>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
          >
            <a href="https://www.asta.org/" target="_blank">
              <img
                class="img-fluid"
                src="~rhomtrip_assets/src/img/partnership/asta-travel-advisors.png"
                alt="asta"
            /></a>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
          >
            <a href="https://www.octo.travel" target="_blank">
              <img
                class="img-fluid"
                src="~rhomtrip_assets/src/img/partnership/octo-travel.png"
                alt="octo"
            /></a>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
          >
            <a href="https://www.tripadvisor.com" target="_blank">
              <img
                class="img-fluid"
                src="~rhomtrip_assets/src/img/partnership/tripadvisor-2023.png"
                alt="tripadvisor"
            /></a>
          </div>
        </div>
      </div>
      <div class="border-top pt-3 text-center col-12">
        <div class="d-block">
          <a
            href="https://rhomtrip.com/terms-conditions/"
            class="text-sm"
            target="_blank"
            >Terms and conditions
          </a>
          |
          <a
            href="https://rhomtrip.com/privacy-policy/"
            class="text-sm"
            target="_blank"
            >Privacy Policy
          </a>
          |
          <a
            href="https://rhomtrip.com/contact/"
            class="text-sm"
            target="_blank"
            >Contact us
          </a>
        </div>

        © {{ systemInfo.year }} RhomTrip OÜ™. All Rights Reserved.
      </div>
    </modal>
  </div>
</template>

<script>
// Dependencies
import "@/scss/styles.scss";
import { mapGetters, mapMutations } from "vuex";
import { CollapseTransition } from "vue2-transitions";
import flatPicker from "vue-flatpickr-component";
import Swal from "sweetalert2";
import Pusher from "pusher-js";
import "flatpickr/dist/flatpickr.css";

// Internal components and services
import { DocumentsAPI } from "@/core/api";
import WSelect from "@/components/Select";
import { removeCredentials, ROLE_HIERARCHY } from "@/helpers/commons.helpers";

// Component configuration
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

/**
 * Dashboard Navigation Bar Component
 *
 * Manages the top navigation bar with user profile, notifications,
 * release notes, and session management functionality.
 *
 * @component
 * @example
 * <DashboardNavbar type="default" :table="tableData" />
 */
export default {
  name: "DashboardNavbar",

  props: {
    /**
     * Visual style of the navbar
     * @type {String}
     * @default 'default'
     * @description Look of the dashboard navbar. Default (Green) or light (gray)
     */
    type: {
      type: String,
      default: "default",
      validator: value => ["default", "light"].includes(value),
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    },

    /**
     * Table data for filtering operations
     * @type {Array}
     * @description Table to be filter
     */
    table: {
      type: Array,
      description: "Table to be filter"
    }
  },

  data() {
    return {
      /** @type {boolean} Controls notification dropdown visibility */
      activeNotifications: false,

      /** @type {boolean} Controls about modal visibility */
      about: false,

      /** @type {string[]} Allowed user roles for pusher notifications */
      roles: ROLE_HIERARCHY,

      /** @type {Pusher|null} Pusher instance for real-time notifications */
      pusher: null,

      /** @type {boolean} Controls release sidebar visibility */
      visibleSideBarReleases: false,

      /** @type {Array} Sample notifications data (will be replaced with real-time data) */
      notifications: [],

      /** @type {Array} Release notes data */
      releases: [],

      /** @type {boolean} Loading state for release operations */
      loader: false,
      /** @type {Pusher.Channel|null} Pusher channel subscription */
      subscribeChannel: null,
      /** @type {string} Default user profile image path */
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png")
    };
  },
  watch: {
    /**
     * Watches for sign out events and triggers session finish
     * @param {any} newVal - New sign out value
     * @param {any} oldVal - Previous sign out value
     */
    sigout: {
      handler(current, old) {
        if (current.length > 0) {
          this.sesionFinish();
        }
      },
      deep: true
    }
  },

  /**
   * Component lifecycle - Initialize Pusher connection
   * Sets up real-time notifications and event subscriptions
   */
  async created() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.subscribeChannel = this.pusher.subscribe("rhombuss");
    this.watchUserUpdates(this.subscribeChannel, "users");
  },
  methods: {
    // =============================================================================
    // SESSION MANAGEMENT
    // =============================================================================

    /**
     * Logs out the current user and cleans up application state
     * Clears local storage, resets store values, and redirects to sign in
     */
    logout() {
      document.body.style.removeProperty("--primary-tooltip");
      // Reset store state
      this.setResponseReservations({});
      this.setOperatorRespose({});
      this.setResponseBranch({});
      this.setResponseArea({});
      this.setVehicles({});
      removeCredentials();
      this.setSesion(null);
      this.$router.push({ path: "/signin" });
    },

    /**
     * Handles session expiration with user confirmation
     * Shows a modal to inform the user about session expiration
     */
    async sesionFinish() {
      const { value } = await Swal.fire({
        title: "Your session has expired",
        html:
          "For you security your current session has expired and you have been logged out.",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "",
        cancelButtonClass: "btn btn-link",
        confirmButtonText: "Accept",
        confirmButtonClass: "btn btn-primary btn-small"
      });

      if (value) {
        this.logout();
      }
    },

    // =============================================================================
    // UI UTILITIES
    // =============================================================================

    /**
     * Toggles the main sidebar visibility
     */
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    // =============================================================================
    // REAL-TIME NOTIFICATIONS (PUSHER)
    // =============================================================================

    /**
     * Subscribes to Pusher events for real-time notifications
     * @param {Pusher.Channel} channel - Pusher channel to bind events to
     * @param {string} event - Event name to bind to the channel
     */
    watchUserUpdates(channel, event) {
      channel.bind(event, async data => {
        const isSameUserId = data.userId === this.sesion.id;
        const hasValidRole = this.roles.includes(this.sesion.role);
        if (hasValidRole && isSameUserId) {
          if (this.sesion.role !== data.type) {
            await this.logoutBySensitiveChanges();
          } else {
            await this.reloadInformation();
          }
        }
      });
    },

    /**
     * Handles information updates that require page reload
     * Shows modal to inform user about updates and prompts for page reload
     */
    async reloadInformation() {
      const { value } = await Swal.fire({
        title: "Information Updated!",
        html:
          "Your information has been updated. Please reload the page to see the changes.",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "",
        cancelButtonClass: "btn btn-link",
        confirmButtonText: "Reload Page",
        confirmButtonClass: "btn btn-primary btn-small"
      });

      if (value) {
        this.reloadPage();
      }
    },

    /**
     * Reloads the current page
     */
    reloadPage() {
      this.$router.go();
    },

    /**
     * Handles sensitive changes that require re-authentication
     * Shows modal and forces logout for security reasons
     */
    async logoutBySensitiveChanges() {
      const { value } = await Swal.fire({
        title: "Information Updated!",
        html:
          "Your information has been updated. Please log in again due to sensitive changes.",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "",
        cancelButtonClass: "btn btn-link",
        confirmButtonText: "Accept",
        confirmButtonClass: "btn btn-primary btn-small"
      });

      if (value) {
        this.logout();
      }
    },
    // =============================================================================
    // RELEASE NOTES MANAGEMENT
    // =============================================================================

    /**
     * Opens the release notes sidebar
     * Fetches latest releases and marks them as viewed if there are new ones
     */
    async openSideBarReleases() {
      try {
        this.visibleSideBarReleases = true;
        this.loader = true;

        this.releases = await this.getReleasesByApp("INTERNAL");
        // Mark latest news as viewed if available
        if (this.latestNewsAvailable) {
          const latestNewsAvailable = await this.markReleaseAsWatched(
            "INTERNAL",
            this.systemInfo.release.version,
            {
              user: {
                type: "Users",
                ref: this.sesion.id
              },
              hasViewed: true
            }
          );
          this.setLatestNewsAvailable(latestNewsAvailable);
        }
      } catch (error) {
        console.error("Error opening sidebar releases:", error);
      } finally {
        this.loader = false;
      }
    },

    /**
     * Closes the release notes sidebar
     * @param {boolean} status - New visibility status
     */
    closeSidebarReleases(status) {
      this.visibleSideBarReleases = status;
    },

    /**
     * Fetches release notes for a specific application
     * @param {string} app - Application identifier (e.g., 'INTERNAL')
     * @returns {Promise<Array>} Array of release notes or empty array on error
     */
    async getReleasesByApp(app) {
      try {
        const { data } = await DocumentsAPI.getReleasesByApp(
          app,
          this.sesion.token
        );
        return data.status ? data.data : [];
      } catch (error) {
        console.error("Error fetching releases:", error);
        return [];
      }
    },

    /**
     * Marks a specific release as watched by the current user
     * @param {string} app - Application identifier
     * @param {string} releaseVersion - Version of the release
     * @param {Object} payload - User information and viewed status
     * @returns {Promise<boolean>} Returns false if successfully marked, true otherwise
     */
    async markReleaseAsWatched(app, releaseVersion, payload) {
      try {
        const { data } = await DocumentsAPI.markReleaseAsWatched(
          app,
          releaseVersion,
          payload,
          this.sesion.token
        );
        return !data.status;
      } catch (error) {
        console.error("Error marking release as watched:", error);
        return true;
      }
    },
    // =============================================================================
    // VUEX MUTATIONS
    // =============================================================================

    ...mapMutations([
      "setResponseReservations",
      "setOperatorRespose",
      "setResponseArea",
      "setResponseBranch",
      "setVehicles",
      "setLoad",
      "setSettings",
      "setItemsBread",
      "setLatestNewsAvailable",
      "setSesion"
    ])
  },

  computed: {
    // =============================================================================
    // VUEX GETTERS
    // =============================================================================

    ...mapGetters([
      "load",
      "sesion",
      "profile",
      "sigout",
      "itemsBread",
      "systemInfo",
      "latestNewsAvailable"
    ])
  },
  components: {
    CollapseTransition,
    flatPicker,
    WSelect
  },

  /**
   * Component cleanup - Disconnect Pusher when component is destroyed
   * Ensures no memory leaks from WebSocket connections
   */
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  }
};
</script>
